import React, { useState, useEffect, useCallback } from 'react';
import * as echarts from 'echarts';
import BaseChart from '@components/common/BaseChart';
import { buildSankeyOption } from './utils';

const Sankey = ({ data, type }) => {
  const [instance, setInstance] = useState<echarts.ECharts | null>(null);
  const chartInstanceRefCb: any = useCallback((instance) => {
    setInstance(instance);
  }, []);

  useEffect(() => {
    if (instance !== null) {
      const option = buildSankeyOption(data, type);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      instance.setOption(option, { notMerge: true });
    }
  }, [instance, data, type]);

  return (
    <BaseChart
      key="sankey-resiliency"
      chartId="sankey-resiliency"
      chartInstanceRefCb={chartInstanceRefCb}
      style={{ height: 500 }}
    />
  );
};

export default Sankey;
